<template>
  <a class="wrapper" :href="`https://www.infoq.cn/article/${data.uuid}`" target="_blank">
    <div class="info">
      <h2 class="title">{{ data.article_title }}</h2>
      <div class="publish_time">
        <i class="geekbang-icon">&#xe6ac;</i>
        {{ data.publish_time | formatTime }}
      </div>

      <p class="summary">{{ data.article_summary }}</p>
    </div>
  </a>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
   filters: {
     formatTime (time) {
       return moment(time).format('YYYY 年 M 月 D 日')
     }
   }
}
</script>

<style lang="scss" scoped>
@import '~@/style/variable.sass';
$padding: 16px;

.wrapper {
  .info {
    padding-left: $padding;
    padding-right: $padding;
  }
  &:hover {
    .title {
      color: $primary;
    }
  }
  .title {
    color: #353535;
    font-size: 17px; font-weight: 500;
    transition: all 0.3s linear;
    @include limit-line-numbers(1);
  }
  .publish_time {
    color: #A7A7A7;
    font-size: 14px;
    margin-top: 2px;
    .geekbang-icon {
      font-size: 13px;
    }
  }
  .summary {
    color: #666666;
    font-size: 14px;
    margin-top: 5px;
    @include limit-line-numbers(2);
  }
}

</style>
